$(window).on('load' ,function(){
  if (sessionStorage.getItem("SwatchColor") === null) {
   getColormediaId("Black");
  }else{
    var Swatch_color = sessionStorage.getItem("SwatchColor")
    getColormediaId(Swatch_color)
    $(".swatch-container").removeClass("swatch-active");
    $('.swatch-container[data-title="'+ Swatch_color +'"]').each(function(){ $(this).addClass("swatch-active");});
  }
   $(".swatch-group .selected-color").text("Black");
  $(".swatch-container").click(function(){
      var clicked = $(this);
      $(".swatch-container").not(clicked).removeClass("swatch-active");
      $(this).addClass("swatch-active");
      var swatch_color = $(this).attr("data-title");
      $('.product-block__image').removeClass("product-block__image--active");
      getColormediaId(swatch_color);
      if(swatch_color == "None"){
       $('.product-block-options__inner .product-block-options__item[data-option-item="Canvas Only"]').each(function(){ $(this).trigger("click"); });
      }
      $(".swatch-group .selected-color").text(swatch_color);
      sessionStorage.setItem('SwatchColor', $(this).attr("data-title"));
  });
});

function getColormediaId(swatch_color) {
    $('.product-info').each(function() {
        var $productInfo = $(this);
        var $productOptions = $productInfo.find('.product-block-options__inner');
       var is_media_id;
        if($productOptions.find('.product-block-options__item[data-option-item="'+swatch_color+'"]').length === 0 ){
          var $productImage = $productOptions.find('.product-block-options__item').parents(".block-inner-inner").find('.image-cont');
             $productImage.find('.product-block__image.product-block__image--primary').addClass("product-block__image--active");
        }else{
           var optionMediaId = $productOptions.find('.product-block-options__item[data-option-item="'+swatch_color+'"]').data('option-item');
          is_media_id = $productOptions.find('.product-block-options__item[data-option-item="'+swatch_color+'"]').data('media');
          if( optionMediaId === swatch_color){
              is_media_id = $productOptions.find('.product-block-options__item[data-option-item="'+swatch_color+'"]').data('media');
              var $productImage = $productOptions.find('.product-block-options__item[data-option-item="'+swatch_color+'"]').parents(".block-inner-inner").find('.image-cont');
              var $mediaIDPrdo = $productImage.find('.product-block__image[data-media-id = "' + is_media_id + '"]');
              $productImage.find('.product-block__image[data-media-id = "' + is_media_id + '"]').addClass("product-block__image--active");
              if( $mediaIDPrdo.hasClass('product-block__image--inactivated') ){
                $mediaIDPrdo.removeClass('product-block__image--inactivated');
              }
            }
        }
    });
   
}
